// Markdown wraps block components in the flow of the prose, so the button keeps
// the vertical rhythm of the paragraphs around it.
.root {
	margin-block: var(--mantine-spacing-lg);
}

// www.surrealdb.com's solid call to action, in the product accent: a lilac
// pill with white text, where the white arrow opens beside the label on hover.
.button {
	display: inline-flex;
	align-items: center;
	height: 48px;
	padding: 0 24px;
	border-radius: 999px;
	background: var(--docs-accent);
	color: var(--docs-accent-contrast);
	font-size: 16px;
	font-weight: 500;
	line-height: 1;
}

// The apex site's hover arrow: a masked glyph in the text colour, held at no
// width until hover, when it opens beside the label.
.label {
	display: inline-flex;
	align-items: center;

	&::after {
		content: "";
		display: inline-block;
		flex: 0 0 auto;
		width: 1.325em;
		max-width: 0;
		height: 1.325em;
		margin-left: 0;
		margin-right: 0;
		opacity: 0;
		background-color: currentColor;
		mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M2.75 10H16.75m-6.25-5.75L16.75 10l-6.25 5.75' stroke='%23000' stroke-width='1.25' stroke-linecap='square' stroke-linejoin='miter'/%3E%3C/svg%3E") center / contain no-repeat;
		transition:
			max-width 450ms cubic-bezier(0.22, 1, 0.36, 1),
			margin-left 450ms cubic-bezier(0.22, 1, 0.36, 1),
			margin-right 450ms cubic-bezier(0.22, 1, 0.36, 1),
			opacity 350ms;
	}

	.button:hover &::after,
	.button:focus-visible &::after {
		max-width: 1.325em;
		margin-left: 12px;
		margin-right: -6px;
		opacity: 1;
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			transition: none;
		}
	}
}
